import { useEffect, useRef, useState } from "react";
import { Button, Card, Row } from "react-bootstrap";
import { getHappycallVarianceList, setServiceHappycallVarianceToVerified } from "../store/api/HappycallAPI";
import DatePicker from "react-datepicker2";
import moment from "moment-jalali";
import { Check2Square, Clipboard2DataFill, FileEarmarkExcelFill, Headphones, PrinterFill } from "react-bootstrap-icons";
import BihamtaTable from "../../Components/BihamtaTable";
import Loader from "react-loader-spinner";
import ModalSelectStaff from "../../Components/Modals/ModalSelectStaff";
import ModalPrintViewer from "../../Components/Modals/ModalPrintViewer";
import { exportToExcel, setErrorDialog } from "../../store/api/CommonFunctions";
import ModalHappyCall from "../../Components/Modals/ModalHappyCall";
import { useDispatch } from "react-redux";
import { getAllProvinces } from "../../store/api/LocationAPI";


export default function HappycallVarianceList() {
    const dispatch = useDispatch();
    const [pending, setPending] = useState(false);
    const inputCDateFrom = useRef();
    const inputCDateTo = useRef();
    const inputEDateFrom = useRef();
    const inputEDateTo = useRef();
    const inputDateFrom = useRef();
    const inputDateTo = useRef();
    const [searchData, setSearchData] = useState({});
    const [modalStaff, setModalStaff] = useState({ show: false });
    const [modalPrintData, setModalPrintData] = useState({ show: false });
    const [modalHappycall, setModalHappyCall] = useState({ show: false });
    const tableCols = [
        { colTitle: "ردیف", colName: "RowNumber", showInMobile: true },
        { colTitle: "سرویس", colName: "PServiceType+InvoiceNumber", showInMobile: true, colType: "string" },
        { colTitle: "تاریخ پذیرش", colName: "PFirstContactDate" },
        { colTitle: "مشتری", colName: "CustomerCode+CustomerName", colType: "string" },
        { colTitle: "شماره تماس مشتری", colName: "CustomerPhone+CustomerMobile", colType: "string" },
        { colTitle: "تکنسین", colName: "StaffName" },
        { colTitle: "شماره تماس تکنسین", colName: "StaffPhone+StaffMobile", colType: "string" },
        { colTitle: "دریافتی ثبت شده", colName: "CustomerPayment", colType: "currency" },
        { colTitle: "دریافتی به اظهار مشتری", colName: "HappycallCost", colType: "currency" },
        { colTitle: "اختلاف دریافتی", colName: "Variance", colType: "currency", styleCondition: (row) => row.Variance > 0 ? { color: "red" } : { color: "green" } },
        { colTitle: "شرح اختلاف", colName: "VarianceDesc", styleCondition: (row) => row.Variance > 0 ? { color: "red" } : { color: "green" } },
        { colTitle: "توضیحات رضایت سنجی", colName: "HappycallDesc" },
        { colTitle: "بررسی شده", colName: "IsVerified", colType: "boolean" }
    ]
    const rowButtons = [
        {
            title: "پرسشنامه",
            type: "common",
            tooltip: "پرسشنامه",
            //className: string;
            onclick: showModalHappyCall,
            icon: <Headphones size={18} color="blue" className="rowBtn" />
        },
        {
            title: "بررسی شد",
            type: "common",
            tooltip: "بررسی شد",
            onclick: setVerify,
            showCondition: (row) => !row.IsVerified,
            icon: <Check2Square size={18} color="green" className="rowBtn" />
        }

    ]
    const onServiceTypeChange = (serviceType) => {
        searchData.ServiceType = serviceType;
    }
    function setVerify(row) {
        const onSet = (res) => {
            if (res.Data) {
                setErrorDialog(dispatch, "success", "بررسی اختلاف دریافتی");
                search();
            }
            else if (res.Error) {
                setErrorDialog(dispatch, res.Error, "بررسی اختلاف دریافتی");
            }

        }
        setServiceHappycallVarianceToVerified(row.ServiceID, row.ServiceType, onSet);
    }
    const search = () => {

        if (inputCDateFrom.current.input.value === "") {
            searchData.CreateDateFrom = null;
        }
        if (inputCDateTo.current.input.value === "") {
            searchData.CreateDateTo = null;
        }
        if (inputDateFrom.current.input.value === "") {
            searchData.FirstContactDateFrom = null;
        }
        if (inputDateTo.current.input.value === "") {
            searchData.FirstContactDateTo = null;
        }
        if (inputEDateFrom.current.input.value === "") {
            searchData.EventDateFrom = null;
        }
        if (inputEDateTo.current.input.value === "") {
            searchData.EventDateTo = null;
        }
        searchData.Take = searchData.Take ?? 10;
        searchData.Skip = 0;
        dispatch(getHappycallVarianceList(searchData));
    }
    const onPageChange =(data)=>{
         dispatch(getHappycallVarianceList(data));
    }    
    const showService = (row) => {
        if (Number(row.ServiceID) > 0)
            window.open(`/Services/Service/${row.ServiceID}/${row.ServiceType}`);
    }
    const handlePrint = (e) => {
        setModalPrintData({ show: true, designMode: e.ctrlKey, reportName: "HappycallVarianceList" });
    }
    function toExcel() {
        const url = "api/HappycallAPI/getHappycallVarianceList";
        const searchArgs = { ...searchData };
        setPending(true);
        exportToExcel("HappycallVarianceList", searchArgs, url, "post", tableCols, () => setPending(false));
    }
    function showModalHappyCall(row) {
        if (!(Number(row.ServiceID) > 0)) {
            return;
        }
        setModalHappyCall({
            show: true,
            ProductID: row.ProductID,
            ServiceType: row.ServiceType,
            ServiceID: row.ServiceID,
            ProductName: row.ProductName,
            ProductModel: row.ProductModel,
            InvoiceNumber: row.InvoiceNumber,
            PServiceType: row.ServiceType === "repair" ? "تعمیر" : "نصب",
            ProductSerial: row.ProductSerial,
            CustomerName: row.CustomerName,
            CustomerPhone: row.CustomerPhone,
            CustomerMobile: row.CustomerMobile,
            ContactDate: row.FirstContactDate ? moment(row.FirstContactDate).format("jYYYY/jMM/jDD HH:mm") : "",
            SendDeliveryDate: row.SendDeliveryDate ? moment(row.SendDeliveryDate).format("jYYYY/jMM/jDD HH:mm") : ""
        })
    }
    useEffect(() => {
        dispatch(getAllProvinces());
        document.body.classList = 'notMain';
        document.title = "بی همتا-مشتریان";
    }, []);
    return (
        <div className="container-fluid mt-1" style={{ minHeight: '80vh', textAlign: "right" }}>
            <Card>
                <Card.Header className="headerStyle">گزارش کنترل دریافتی</Card.Header>
                <Card.Body className="bodyStyle" style={{ textAlign: "right" }}>
                    <ModalPrintViewer modalData={modalPrintData} setModalData={setModalPrintData}
                        dataUrl="api/HappycallAPI/getHappycallVarianceList"
                        method="post"
                        fetchBody={{ ...searchData, Take: 0, Skip: 0 }} />
                    <ModalSelectStaff popData={modalStaff} setPopSelectStaff={setModalStaff} />
                    <ModalHappyCall popData={modalHappycall} setPopData={setModalHappyCall} />
                    <br />
                    <Row className="rowBorder">
                        <div className="col-md-2 form-group">
                            <label>نوع سرویس:</label>
                            <select className="search-input" onChange={e => onServiceTypeChange(e.target.value)}>
                                <option value="">انتخاب کنید</option>
                                <option value="repair">تعمیر</option>
                                <option value="install">نصب</option>
                            </select>
                        </div>
                        <div className="col-md-2 form-group">
                            <label>تاریخ پذیرش از:</label>
                            <DatePicker ref={inputDateFrom} isGregorian={false} timePicker={false} className="search-input"
                                value={searchData.FirstContactDateFrom ? moment(searchData.FirstContactDateFrom) : null}
                                onChange={value => { searchData.FirstContactDateFrom = value.local("en").format("YYYY/MM/DD") }} />
                        </div>
                        <div className="col-md-2 form-group">
                            <label htmlFor="">تاریخ پذیرش تا:</label>
                            <DatePicker ref={inputDateTo} isGregorian={false} timePicker={false} className="search-input"
                                value={searchData.FirstContactDateTo ? moment(searchData.FirstContactDateTo) : null}
                                onChange={value => { searchData.FirstContactDateTo = value.local("en").format("YYYY/MM/DD") }} />
                        </div>
                        <div className="col-md-2 form-group">
                            <label>تاریخ ثبت از:</label>
                            <DatePicker ref={inputCDateFrom} isGregorian={false} timePicker={false} className="search-input"
                                value={searchData.CreateDateFrom ? moment(searchData.CreateDateFrom) : null}
                                onChange={value => { searchData.CreateDateFrom = value.local("en").format("YYYY/MM/DD") }} />
                        </div>
                        <div className="col-md-2 form-group">
                            <label>تاریخ ثبت تا:</label>
                            <DatePicker ref={inputCDateTo} isGregorian={false} timePicker={false} className="search-input"
                                value={searchData.CreateDateTo ? moment(searchData.CreateDateTo) : null}
                                onChange={value => { searchData.CreateDateTo = value.local("en").format("YYYY/MM/DD") }} />
                        </div>
                        <div className="col-md-2 form-group">
                            <label>تاریخ انجام از:</label>
                            <DatePicker ref={inputEDateFrom} isGregorian={false} timePicker={false} className="search-input"
                                value={searchData.EventDateFrom ? moment(searchData.EventDateFrom) : null}
                                onChange={value => { searchData.EventDateFrom = value.local("en").format("YYYY/MM/DD") }} />
                        </div>
                        <div className="col-md-2 form-group">
                            <label>تاریخ انجام تا:</label>
                            <DatePicker ref={inputEDateTo} isGregorian={false} timePicker={false} className="search-input"
                                value={searchData.EventDateTo ? moment(searchData.EventDateTo) : null}
                                onChange={value => { searchData.EventDateTo = value.local("en").format("YYYY/MM/DD") }} />
                        </div>
                        <div className="col-md-2 form-group">
                            <label>وضعیت:</label>
                            <select className="search-input" onChange={e => searchData.IsVerified = e.target.value}>
                                <option value="">انتخاب کنید</option>
                                <option value={false}>بررسی نشده</option>
                                <option value={true}>بررسی شده</option>
                            </select>
                        </div>
                        <div className="col-md-2 form-group">
                            <label>تعداد در صفحه:</label>
                            <select className="search-input" onChange={e => searchData.Take = e.target.value}>
                                <option value="">تمام ردیفها</option>
                                <option value={10}>10 ردیف</option>
                                <option value={20}>20 ردیف</option>
                                <option value={50}>50 ردیف</option>
                                <option value={100}>100 ردیف</option>
                                <option value={1000}>1000 ردیف</option>
                            </select>
                        </div>
                    </Row>
                    <Button className="group-Btn mt-1 mb-1" onClick={search}><Clipboard2DataFill size={18} />&nbsp;خروجی گزارش</Button>
                    {!pending &&
                        <div style={{ padding: 3, width: "100%", textAlign: "left", marginTop: "1px" }}>
                            <FileEarmarkExcelFill onClick={toExcel} size={25} color="green" style={{ cursor: "pointer" }} className="hoverIcon" />&nbsp;
                            <PrinterFill onClick={handlePrint} size={25} color="blue" style={{ cursor: "pointer" }} className="hoverIcon" />
                        </div>}
                    {pending && <div style={{ padding: 0, width: "100%", textAlign: "left" }}><Loader type="BallTriangle" color="#bb1370" height={18} style={{ textAlign: "left", alignItems: "left" }} /></div>}
                    <BihamtaTable rowButtons={rowButtons} columns={tableCols} filterData={searchData} searchMethod={(data)=> onPageChange(data)} reducerName="customerDataReducer" objectName="happycallVarianceList" maxHeight={500} rowClick={showService} hasPaging style={{whiteSpace:"nowrap"}}/>
                </Card.Body>
            </Card>
        </div>
    )
}